import { Form } from "react-bootstrap";

import classes from "../Inventory/inventory.module.scss";

import { ReactComponent as ArrowDown } from "@/assets/images/icons/Inventory/arrow-down.svg";
import { ReactComponent as ArrowUp } from "@/assets/images/icons/Inventory/arrow_up.svg";

import EmptyContainerTableDetail from "./EmptyContainerTableDetail";

import { formatMiles, isMobile } from "@/services/Utils";

const EmptyContainerTable = ({ selected, handleCheckProduct, handleCheckInventory, emptyContainers, setEmptyContainers }) => {
	const handleClick = (i) => {
		let newEmptyContainers = [...emptyContainers];
		newEmptyContainers.forEach((element, j) => {
			if (i !== j) {
				newEmptyContainers[j].active = false;
			}
		});

		newEmptyContainers[i].active = !emptyContainers[i].active;
		setEmptyContainers(newEmptyContainers);
	};

	const validCheck = (i) => {
		let checked = true;

		const findNotChecked = emptyContainers[i].details.filter((detail) => !selected.includes(detail.original_id));

		if (findNotChecked.length !== 0) {
			checked = false;
		}

		return checked;
	};

	return (
		<tbody>
			{emptyContainers.map((container, i) => {
				const otherActive = emptyContainers.filter((fi) => fi.active && fi.product_id !== container.product_id);

				return [
					<tr
						className={`${classes.table_tr}  ${otherActive.length > 0 && classes.otherActive}`}
						onClick={() => isMobile() && handleClick(i)}
						key={i}
					>
						<td className={`${classes.table_td} ${classes.first_td}`}>
							<div className={`${classes.table_div} ${container.active && classes.active} ${classes.first_div}`}>
								<Form.Check type="checkbox" checked={validCheck(i)} onChange={(e) => handleCheckProduct(container, e)} />
							</div>
						</td>

						<td className={`${classes.table_td} `}>
							<div className={`${classes.table_div} ${container.active && classes.active} ${classes.center}`}>{container.tradename}</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${container.active && classes.active} ${classes.center}`}>
								{`${formatMiles(container.container_content)}`}
							</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${container.active && classes.active} ${classes.center}`}>
								{` ${container.unit_measurement}`}
							</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${container.active && classes.active} ${classes.center}`}>
								<strong>{formatMiles(container.container_quantity)}</strong>
							</div>
						</td>
						<td className={`${classes.table_td}`}>
							<div className={`${classes.table_div} ${container.active && classes.active} ${classes.center}`}>
								{container.active ? (
									<ArrowUp className="arrow-icon" onClick={() => handleClick(i)} />
								) : (
									<ArrowDown className="arrow-icon" onClick={() => handleClick(i)} />
								)}
							</div>
						</td>
					</tr>,
					<EmptyContainerTableDetail selected={selected} container={container} handleCheckInventory={handleCheckInventory} key={`detail_${i}`} />,
				];
			})}
		</tbody>
	);
};

export default EmptyContainerTable;
